import React, { Component } from 'react';
import { connect } from 'react-redux';
import VolumeList from './VolumeList';
import { VolumeContainer } from './styles';
import VolumeDetails from './VolumeDetails';
import TemperatureChart from './TemperatureChart';
import DynamicAPI from '../../../../../shared/axios';
import { INTERVAL_GRAPH_POINTS } from './shared/interval-graph-points';

class Volume extends Component {
  constructor(props) {
    super(props);
    
    this.volumeContainerRef = React.createRef();

    this.state = {
      temperatureVolumeList: {
        isLoading: false,
        data: [],
      },
      volumeDetails: {
        isLoading: false,
        showDetailsLayout: false,
        data: [],
        serial: null,
      },
      temperatureDetails: {
        isLoading: false,
        data: [],
        intervalInMinutes: null,
      },
    };
  }

  componentDidMount() {
    this._getTemperatureVolumeListByNF();
  }

  _getTemperatureVolumeListByNF = async () => {
    const { nfData, loggedCompanyId } = this.props;
    
    try {
      this.setState(prevState => ({
        temperatureVolumeList: {
          ...prevState.temperatureVolumeList,
          isLoading: true,
        },
      }));

      const params = {
        tmsId: nfData.tms.tmsId,
        nf: nfData.nf,
        companyId: loggedCompanyId,
        page: 1,
        amount: 10,
      };

      const http = new DynamicAPI('v1');

      const response = await http.get(
        '/Temperature/GetTemperatureVolumeListByNF',
        params,
      );

      this.setState(prevState => ({
        temperatureVolumeList: {
          ...prevState.temperatureVolumeList,
          isLoading: false,
          data: response.data,
        },
      }));
    } catch (error) {
      this.setState(prevState => ({
        temperatureVolumeList: {
          ...prevState.temperatureVolumeList,
          isLoading: false,
        },
      }));
    }
  };

  _getVolumeDetailsBySerial = async (serial) => {
    try {
      this.setState(prevState => ({
        volumeDetails: {
          ...prevState.volumeDetails,
          isLoading: true,
        },
      }));

      const http = new DynamicAPI('v1');

      const response = await http.get(
        '/Temperature/GetVolumeDetailsBySerial',
        {
          serial,
        },
      );

      this._getTemperatureVolumeDetailsBySerial(serial);

      this.setState(prevState => ({
        volumeDetails: {
          ...prevState.volumeDetails,
          isLoading: false,
          data: response.data,
          serial: serial,
          showDetailsLayout: true,
        },
      }));
    } catch (error) {
      this.setState(prevState => ({
        volumeDetails: {
          ...prevState.volumeDetails,
          isLoading: false,
        },
      }));
    }
  };

  _closeDetailsLayout = () => {
    this.setState({
      volumeDetails: {
        ...this.state.volumeDetails,
        showDetailsLayout: false,
      },
    });
  };

  _getTemperatureVolumeDetailsBySerial = async (serial, interval) => {
    try {
      this.setState(prevState => ({
        temperatureDetails: {
          ...prevState.temperatureDetails,
          isLoading: true,
        },
      }));

      const intervalInMinutes = interval ?? INTERVAL_GRAPH_POINTS.THIRTY_MINUTES;

      const http = new DynamicAPI('v1');

      const response = await http.get(
        '/Temperature/GetTemperatureVolumeDetailsBySerial',
        {
          serial,
          interval: intervalInMinutes
        },
      );

      this.setState(prevState => ({
        temperatureDetails: {
          ...prevState.temperatureDetails,
          isLoading: false,
          data: response.data,
          intervalInMinutes: intervalInMinutes,
        },
      }));
    } catch (error) {
      this.setState(prevState => ({
        temperatureDetails: {
          ...prevState.temperatureDetails,
          isLoading: false,
        },
      }));
    }
  };

  render() {
    const { temperatureVolumeList, volumeDetails, temperatureDetails } =
      this.state;

    const showLoading =
      temperatureVolumeList.isLoading ||
      volumeDetails.isLoading ||
      temperatureDetails.isLoading;

    return (
      <VolumeContainer ref={this.volumeContainerRef}>
        {volumeDetails.showDetailsLayout ? (
          <div style={{ width: '100%' }}>
            <VolumeDetails
              volumeDetailsData={volumeDetails.data}
              serial={volumeDetails.serial}
              closeDetailsLayout={this._closeDetailsLayout}
              getTemperatureVolumeDetailsBySerial={this._getTemperatureVolumeDetailsBySerial}
              isLoading={showLoading}
            />
            <TemperatureChart
              data={temperatureDetails.data}
              volumeContainerRef={this.volumeContainerRef}
              intervalInMinutes={temperatureDetails.intervalInMinutes}
              isLoading={showLoading}
            />
          </div>
        ) : (
          <VolumeList
            temperatureVolumeListData={temperatureVolumeList.data}
            getVolumeDetailsBySerial={this._getVolumeDetailsBySerial}
            isLoading={showLoading}
          />
        )}
      </VolumeContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedCompanyId: state.auth.activeCompanyId,
  };
}

export default connect(mapStateToProps)(Volume);
